var pe2 = "/static/cffec2e1e869aeb3.png";

export { pe2 as default };
//# sourceMappingURL=pe_2.png.js.map
